import axios from 'axios';

/* eslint-disable no-shadow */
var SortingDirection;
(function (SortingDirection) {
    SortingDirection["ASC"] = "ASC";
    SortingDirection["DESC"] = "DESC";
})(SortingDirection || (SortingDirection = {}));

const dateISORegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*))(?:Z|(\+|-)([\d|:]*))?$/;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isIsoDateString = (value) => value && typeof value === 'string' && dateISORegex.test(value);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const handleDates = (body) => {
    if (body === null || body === undefined || typeof body !== 'object') {
        return;
    }
    for (const key of Object.keys(body)) {
        const value = body[key];
        if (isIsoDateString(value)) {
            // eslint-disable-next-line no-param-reassign
            body[key] = new Date(value);
        }
        else if (typeof value === 'object') {
            handleDates(value);
        }
    }
};

const httpClient = (baseUrl) => {
    const defaultOptions = {
        baseURL: baseUrl,
    };
    const instance = axios.create(defaultOptions);
    instance.interceptors.response.use((originalResponse) => {
        handleDates(originalResponse.data);
        return originalResponse;
    });
    return instance;
};

class ClientBase {
    httpClient;
    environment;
    _logger;
    constructor(baseUrl, env, logger) {
        this.httpClient = httpClient(baseUrl);
        this.environment = env;
        this._logger = logger;
    }
    // Method to parse errors to default error format
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    processError(err, message, ...logData) {
        if (err.response) {
            // Request made and server responded
            if (err.response.status === 404) {
                this._logger?.info(`404 response: ${message}`, err, ...logData);
                // Return null on NotFound exception
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return { success: true, data: null };
            }
            const errors = [];
            if (err.response.data?.error?.errors) {
                errors.push(...err.response.data.error.errors);
            }
            else {
                errors.push({
                    title: err.message,
                    type: 'UnhandledException',
                });
            }
            this._logger?.error(`Error from module: ${message}`, err, ...logData);
            return {
                success: false,
                error: {
                    errors,
                    status: err.response.status,
                    stack: err.response.data?.stack,
                },
            };
        }
        let stack;
        if (this.environment !== 'prod' && this.environment !== 'production') {
            stack = err.stack;
        }
        this._logger?.error(`Connectivity problems: ${message}`, err, ...logData);
        // The request was made but no response was received
        return {
            success: false,
            error: {
                errors: [
                    {
                        title: err.message,
                        type: 'UnhandledException',
                    },
                ],
                status: 503,
                stack,
            },
        };
    }
}

class CachedClientBase extends ClientBase {
    _redisClient;
    constructor(baseUrl, env, redisClient, logger) {
        super(baseUrl, env, logger);
        this._redisClient = redisClient;
    }
    getRedisClient() {
        if (this._redisClient && this._redisClient.isReady) {
            return this._redisClient;
        }
        return undefined;
    }
}

export { CachedClientBase, ClientBase, SortingDirection };
//# sourceMappingURL=index.js.map
